module.exports = __webpack_public_path__ + "img/LOGO-Master.39c6bba6.svg";